export default __webpack_public_path__ + "static/media/Ambiente e Gestão do Território.2054af12.pdf";